import {
    Input,
    InputGroup,
    InputLeftElement,
    Box,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { colors } from 'src/common/colors'

type Props = {
    placeholder?: string;
    value: string;
    marginBottom?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InfoSearchBar = (props: Props) => {
    return (
        <>
            <InputGroup display='flex' alignItems='center' marginBottom={props.marginBottom}>
                <InputLeftElement pointerEvents='none' height='100%' marginLeft='20px' width='23px'>
                    <SearchIcon boxSize='24px' color={colors.darkBlue} width='100%' height='23px' flexShrink='0' />
                </InputLeftElement>
                <Box width='100%'>
                    <Input
                        placeholder={props.placeholder}
                        value={props.value}
                        onChange={props.onChange}
                        height='61px'
                        fontSize='16px'
                        paddingLeft='60px'
                        border={`1px solid ${colors.lightGrey}`}
                        borderRadius='0'
                        _placeholder={{
                            color: colors.darkBlue,
                            opacity: 0.63,
                            fontSize: '13px',
                        }}
                    />
                </Box>
            </InputGroup>
        </>
    );
};